<template>
  <el-form class="edit-product-quotation__base-info"
           ref="editForm"
           label-width="150px"
           size="small"
           :inline="true"
           @submit.native.prevent>
    <div class="form-card-box">
      <el-form-item label="生效时间" class="custom-range">
        <el-date-picker :value="timeArray"
                        size="small"
                        disabled
                        type="datetimerange"
                        value-format="yyyy-MM-dd HH:mm"
                        range-separator="至"
                        start-placeholder=""
                        end-placeholder=""
                        clearable>
        </el-date-picker>
      </el-form-item>
      <br/>
      <el-form-item label="运力商产品名称">
        <el-input :value="data.lineProductName"
                  size="small"
                  disabled
                  class="edit-form__input"
                  placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="货代拼产品名称">
        <el-input :value="data.productname"
                  size="small"
                  disabled
                  class="edit-form__input"
                  placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="专线渠道代码">
        <el-input :value="data.carrierProductCode"
                  size="small"
                  disabled
                  class="edit-form__input"
                  placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="起运地">
        <el-input :value="data.polnamec"
                  size="small"
                  disabled
                  class="edit-form__input"
                  placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="目的国家">
        <el-input :value="data.podnamec"
                  size="small"
                  disabled
                  class="edit-form__input"
                  placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="收货城市">
        <el-input :value="joinCityNameText(data.polCityList||[])"
                  size="small"
                  disabled
                  class="edit-form__input"
                  placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="运输方式">
        <el-input :value="data.transportNamec || allTransportTypesMapObject[data.transportType]||data.transportType"
                  size="small"
                  disabled
                  class="edit-form__input"
                  placeholder=""></el-input>
      </el-form-item>
      <el-form-item :label="`${transportCodeMapping[data.transportType] || '运输'}公司`">
        <el-input :value="joinShippingCompanyText(data.shippingCompanyList||[])"
                  disabled
                  size="small"
                  class="edit-form__input"
                  placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="运输方案名称">
        <el-input :value="data.transportScheme"
                  size="small"
                  disabled
                  class="edit-form__input"
                  placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="海外仓">
        <el-input :value="data.overseasWarehouse"
                  size="small"
                  disabled
                  class="edit-form__input"
                  placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="派送方式">
        <el-input :value="data.deliveryType||''"
                  size="small"
                  disabled
                  class="edit-form__input"
                  :style="{ width: ['海派','HP','空派','FP'].includes(data.deliveryType) ? '100px' : '200px' }"
                  placeholder=""></el-input>
      </el-form-item>
      <el-form-item label=""
                    label-width="0"
                    v-if="['海派','HP','空派','FP', '卡航', 'KH', 'TL', '铁路'].includes(data.deliveryType)">
        <el-input :value="data.endDeliveryTypeNames || ''"
                  size="small"
                  disabled
                  class="edit-form__input"
                  style="width: 95px"
                  placeholder=""></el-input>
      </el-form-item>
      <template v-if="data.deliveryType !== 'ZT'">
        <el-form-item label="是否支持自提">
          <el-select v-model="data.selfDelivery"
                     disabled
                     size="small"
                     class="edit-form__input"
                     placeholder="请选择">
            <el-option v-for="item in selfDeliveryList"
                       :label="item.label"
                       :value="item.value"
                       :key="item.value"></el-option>
          </el-select>
        </el-form-item>
      </template>
      <template v-if="['WC','整柜直送'].includes(data.deliveryType)">
        <el-form-item label="船期信息">
          <el-input :value="data.shippingDateInformation"
                    disabled
                    size="small"
                    class="edit-form__input"
                    placeholder=""></el-input>
        </el-form-item>
      </template>
      <div class="custom-divider"></div>

      <el-form-item label="可走货物类型">
        <el-input :value="joinGoodsTypeText(data.goodsTypeList||[])"
                  size="small"
                  disabled
                  class="edit-form__input"
                  placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="计费单位">
        <el-input :value="data.chargeType"
                  size="small"
                  disabled
                  class="edit-form__input"
                  placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="取整方式">
        <el-input :value="integerStyleListMapObject[data.scale]||data.scale"
                  v-if="isKG"
                  size="small"
                  disabled
                  class="edit-form__input"
                  placeholder=""></el-input>
        <el-input :value="integerStyleListMapObject[data.cbmScale]||data.cbmScale"
                  v-if="isCBM"
                  size="small"
                  disabled
                  class="edit-form__input"
                  placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="分泡方式" v-if="isKG">
        <el-input :value="distributeBubbleListMapObject[data.pointsBubbleWay]||data.pointsBubbleWay"
                  size="small"
                  disabled
                  class="edit-form__input"
                  placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="体积重比率" v-if="isKG">
        <el-input :value="data.volumeWeightRatio"
                  size="small"
                  disabled
                  class="edit-form__input"
                  placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="重量转换" v-if="isCBM">
        <el-input :value="data.weightVolumeRatio"
                  size="small"
                  disabled
                  class="edit-form__input"
                  placeholder=""></el-input>
      </el-form-item>
      <el-form-item :label="`${data.transportType === 'LY' ? '车次' : '航期'}信息`">
        <el-form-item label="" label-width="0">
          <el-select v-model="data.closeWarehouseTime"
                     size="small"
                     disabled
                     style="width: 92px;"
                     placeholder="">
            <el-option
              v-for="item in sailingInfoList"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="" label-width="0">
          <el-select v-model="data.startShipmentTime"
                     size="small"
                     disabled
                     style="width: 92px;"
                     placeholder="">
            <el-option
              v-for="item in sailingInfoList"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form-item>
      <div class="custom-divider"></div>
      <el-form-item label="是否接一般贸易">
        <!--<el-radio-group v-model="data.isSupportGeneralTrade" disabled>
          <el-radio :label="item.id" v-for="item in yesOrNo" :key="item.id">{{item.name}}</el-radio>
        </el-radio-group>-->
        <el-input :value="data.isSupportGeneralTrade ? '是' : '否'"
                  disabled size="small" class="edit-form__input"></el-input>
      </el-form-item>
      <!--    <el-form-item label="是否能走私人地址"-->
      <!--                  label-width="130px">-->
      <!--      <el-radio-group v-model="data.isSupportPrivateAddress" disabled>-->
      <!--        <el-radio :label="item.id" v-for="item in yesOrNo" :key="item.id">{{item.name}}</el-radio>-->
      <!--      </el-radio-group>-->
      <!--    </el-form-item>-->
      <el-form-item label="是否包关税">
        <el-input :value="data.containsTheTariffs ? '是' : '否'"
                  disabled size="small" class="edit-form__input"></el-input>
        <!--<el-radio-group v-model="data.containsTheTariffs" disabled>
          <el-radio :label="item.id" v-for="item in yesOrNo" :key="item.id">{{item.name}}</el-radio>
        </el-radio-group>-->
      </el-form-item>
      <el-form-item label="是否需要VAT信息">
        <el-input :value="data.isNeedVat ? '是' : '否'"
                  disabled size="small" class="edit-form__input"></el-input>
        <!--<el-radio-group v-model="data.isNeedVat" disabled>
          <el-radio :label="item.id" v-for="item in yesOrNo" :key="item.id">{{item.name}}</el-radio>
        </el-radio-group>-->
      </el-form-item>
      <el-form-item label="单票最小计费重">
        <el-input :value="data.orderWeightMinimum"
                  size="small"
                  disabled
                  class="edit-form__input4"
                  placeholder=""></el-input>
        <el-form-item label="低于单票最小计费重能否下单"
                      class="inner-form"
                      label-width="210px">
          <el-input :value="data.orderWeightMinimumNotLimit ? '是' : '否'" disabled style="width: 40px"></el-input>
          <!--<el-radio-group v-model="data.orderWeightMinimumNotLimit" disabled>
            <el-radio :label="item.id" v-for="item in yesOrNo" :key="item.id">{{item.name}}</el-radio>
          </el-radio-group>-->
        </el-form-item>
      </el-form-item>
      <el-form-item label="单件最小计费重">
        <el-input :value="data.pieceWeightMinimum"
                  size="small"
                  disabled
                  class="edit-form__input4"
                  placeholder=""></el-input>
        <el-form-item label="低于单件最小计费重能否下单"
                      class="inner-form"
                      label-width="210px">
          <el-input :value="data.pieceWeightMinimumNotLimit ? '是' : '否'" disabled style="width: 40px"></el-input>
          <!--<el-radio-group v-model="data.pieceWeightMinimumNotLimit" disabled>
            <el-radio :label="item.id" v-for="item in yesOrNo" :key="item.id">{{item.name}}</el-radio>
          </el-radio-group>-->
        </el-form-item>
      </el-form-item>
      <br/>

      <el-form-item label="单件最大计费重">
        <el-input :value="data.pieceWeightBiggest"
                  size="small"
                  disabled
                  class="edit-form__input4"
                  placeholder=""></el-input>
        <el-form-item label="低于单件最大计费重能否下单"
                      class="inner-form"
                      label-width="210px">
          <el-input :value="data.pieceWeightBiggestNotLimit ? '是' : '否'" disabled style="width: 40px"></el-input>
         <!-- <el-radio-group v-model="data.pieceWeightBiggestNotLimit" disabled>
            <el-radio :label="item.id" v-for="item in yesOrNo" :key="item.id">{{item.name}}</el-radio>
          </el-radio-group>-->
        </el-form-item>
      </el-form-item>
    </div>
    <div class="form-card-box">
      <el-form-item label="货物入仓测量方式">
        <el-select v-model="data.goodsMeasurementMethod"
                   size="small"
                   disabled
                   class="edit-form__input">
          <el-option :value="1" label="机器量方"></el-option>
          <el-option :value="2" label="皮尺量方"></el-option>
        </el-select>
      </el-form-item>
      <!--<el-form-item label="是否支持线下议价"
                    label-width="123px">
        <el-radio-group v-model="data.whetherSupportedBargaining"
                        size="small"
                        disabled
                        class="edit-form__input">
          <el-radio :label="true">是</el-radio>
          <el-radio :label="false">否</el-radio>
        </el-radio-group>
      </el-form-item>-->
      <br/>
      <el-form-item label="是否支持时效赔付">
        <el-select v-model="data.whetherSupportedCompensate"
                   size="small"
                   disabled
                   class="edit-form__input">
          <el-option :value="true" label="是"></el-option>
          <el-option :value="false" label="否"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="时效赔付标准">
        <el-input v-model="data.supportedCompensateDesc"
                  size="small"
                  maxlength="50"
                  disabled
                  style="width: 550px"
                  class="edit-form__input"></el-input>
      </el-form-item>
      <el-form-item label="是否支持丢货赔付"
                    prop="whetherSupportCompensation">
        <el-select v-model="data.whetherSupportCompensation"
                   size="small"
                   disabled
                   class="edit-form__input">
          <el-option :value="true" label="支持"></el-option>
          <el-option :value="false" label="不支持"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="丢货赔付标准">
        <el-input v-model="data.supportCompensationDesc"
                  size="small"
                  maxlength="50"
                  style="width: 550px"
                  disabled
                  class="edit-form__input"></el-input>
      </el-form-item>
      <br/>
      <el-form-item label="是否限时达产品">
        <el-select v-model="data.whetherGuaranteedDelivery"
                   size="small"
                   disabled
                   class="edit-form__input">
          <el-option :value="true" label="是"></el-option>
          <el-option :value="false" label="否"></el-option>
        </el-select>
      </el-form-item>
      <br/>

      <el-form-item label="产品自定义标签">
        <el-input v-model="data.label1"
                  disabled
                  size="small"
                  class="edit-form__input margin-right-sm"
                  placeholder=""></el-input>
        <el-input v-model="data.label2"
                  disabled
                  size="small"
                  class="edit-form__input margin-right-sm"
                  placeholder=""></el-input>
        <el-input v-model="data.label3"
                  disabled
                  size="small"
                  class="edit-form__input margin-right-sm"
                  placeholder=""></el-input>
      </el-form-item>
    </div>
    <div class="form-card-box">
      <div class=""
           style="margin-bottom: 15px;">
        <button class="el-button button-style-small"
                :class="{'el-button--primary':editorTarget === item.id}"
                style="width: 120px; padding: 0; line-height: 1;"
                :style="editorTarget === item.id ? 'color: #FFF' : ''"
                :disabled="item.disabled"
                v-for="item in editorTargetList"
                @click="changeEditorTarget(item.id)"
                type="button">
          <span>{{item.name}}</span>
        </button>
      </div>

      <div v-html="data[editorTarget]"
           style="padding: 10px;border: 1px #ccc dashed;border-radius: 6px;min-height: 200px;"
      ></div>
    </div>

  </el-form>
</template>

<script>
  import {mapFromArrayToObject} from "../../../../assets/js/utils";
  import {allTransportTypesArray,integerStyleArray,distributeBubbleArray} from "@/components/QuotationManagement/components-productQuotation/baseInfo";
  export default {
    name: "viewBaseInfo",
    props:{
      data:{
        type:Object,
        default:()=>({}),
      }
    },
    data(){
      return{
        /* 选择框 数据 */
        yesOrNo:[
          {name:'是',id:true},
          {name:'否',id:false},
        ],
        allTransportTypes:allTransportTypesArray,//运输方式
        allTransportTypesMapObject:mapFromArrayToObject(allTransportTypesArray,{label: 'name', value: 'value'}),//运输方式
        // 取整方式
        // integerStyleList:integerStyleArray,
        integerStyleListMapObject:mapFromArrayToObject(integerStyleArray),
        // 分泡方式
        // distributeBubbleList:distributeBubbleArray,
        distributeBubbleListMapObject:mapFromArrayToObject(distributeBubbleArray),
        /* 编辑器 */
        editor:null,
        editorTarget:'orderInformation',
        editorTargetList:[
          {name:'下单须知',id:'orderInformation',disabled:false,},
          {name:'特殊要求',id:'specialRequirements',disabled:false,},
          {name:'温馨提示',id:'warmPrompt',disabled:false,},
          {name:'包装要求',id:'packagingRequirements',disabled:false,},
          {name:'赔付标准',id:'compensationStandards',disabled:false,},
        ],
        selfDeliveryList: [
          {label:"是",value:1,},//可自提
          {label:"否",value:2,},//不可自提
          // {label:"必须自提",value:3,},
        ],
        // 截仓起运时间下拉
        sailingInfoList: ['周一','周二','周三','周四','周五','周六','周天'],
        transportCodeMapping: {
          KY: '航空',
          HY: '船运',
          LY: '陆运'
        }
      }
    },
    created(){

    },
    methods:{
      /* 切换 富文本目标 */
      changeEditorTarget(id = ''){
        this.editorTarget = id;
      },
      /**
       * 拼接可走货物类型文本
       * @param list
       * @returns {string}
       */
      joinGoodsTypeText(list = []){
        return list.map(item=>item.goodsTypeName).join(",");
      },
      joinCityNameText(list = []){
        return list.map(item=>item.cityName).join(",");
      },
      joinShippingCompanyText(list = []){
        return list.map(item=>item.shippingCompanyName).join(",");
      }
    },
    computed:{
      timeArray(){
        let arr = [];
        if(this.data.effectiveStartTime) arr[0] = this.data.effectiveStartTime;
        if(this.data.effectiveEndTime) arr[1] = this.data.effectiveEndTime;
        return arr;
      },
      isKG(){
        return !this.isCBM;
        // let type = this.data.chargeType||'';
        // return type.toLowerCase() === 'kg'
      },
      isCBM(){
        let type = this.data.chargeType||'';
        return type.toLowerCase() === 'cbm'
      },
    },
    watch:{

    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/QuotationManagement/components-productQuotation/viewDetails/viewBaseInfo.vue